import { formatPrice } from "../Utils";
import ProfileLayout from "../Container/Layout/ProfileLayout";
import React, { useContext, useEffect, useState } from "react";

import { TransactionGetMyRules } from "../Services/Transactions";

import { LoadingContext } from "../Context";
import { MyRulesType } from "../Structures/Types";
import { Empty } from "../Components/Base";

const MyRules = () => {
  const { loading, setLoading } = useContext(LoadingContext);

  // ==============================================================================

  const [myRules, setMyRules] = useState<MyRulesType[]>([]);

  // ==============================================================================

  useEffect(() => {
    setLoading(true);
    TransactionGetMyRules()
      .then(({ data: res }) => {
        if (res.transaction_status) {
          setMyRules(res.data || []);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  // ==============================================================================

  return (
    <ProfileLayout>
      <Empty
        data={myRules}
        isLoading={loading}
        description="درحال حاضر حکمی برای شما صادر نشده است"
      >
        <div className="col-12">
          <div className="row g-2">
            {myRules.map((rule) => (
              <div key={rule.id} className="col-sm-6 col-md-4">
                <div className="card border p-3 h-100">
                  <div className="position-relative">
                    <div className="position-relative z-index-9">
                      <img
                        className="card-img"
                        src={rule.rule.thumbnail}
                        alt={rule.rule.title}
                      />
                    </div>
                  </div>

                  <div className="card-body text-center p-3 px-0">
                    <h5 className="card-title">{rule.rule.title}</h5>
                    <h6 className="mb-0 text-success">
                      {formatPrice(rule.rule.price)} تومان
                    </h6>
                  </div>
                  <a
                    download={true}
                    href={rule.rule_image}
                    className="w-100 btn btn-primary-soft m-0"
                  >
                    دانلود حکم
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Empty>
    </ProfileLayout>
  );
};

export default MyRules;
